export const environment = {
  production: true,

    URL_BASE_BACK_END_SPRING_CLOUD_ZUUL:'https://springcloudzuul-app.centrus.org.br/'
};



// WEBPACK FOOTER //
// /usr/src/app/src/environments/environment.ts